<template>
  <section class="section">
    <div class="container">
      <div class="box">
        <h3>予期せぬエラーが発生しました</h3>
        <div>
          エラーメッセージ：{{ errorMessage }}
        </div>
      </div>
      
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      errorMessage: state => state.error.message
    })
  }
}
</script>